module.exports = __webpack_public_path__ + "img/telegram-logo.c6c6e1bd.svg";